document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('auth-popup');
  const openBtn = document.getElementById('open-auth-popup');
  const closeBtn = document.getElementById('close-auth-popup');
  const overlay = document.querySelector('.auth-overlay');

  if (!popup) return;

  /* ================= OPEN / CLOSE ================= */

  const openPopup = () => {
    popup.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  };

  const closePopup = () => {
    popup.classList.add('hidden');
    document.body.style.overflow = '';
  };

  if (openBtn) {
    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openPopup();
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (overlay) overlay.addEventListener('click', closePopup);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !popup.classList.contains('hidden')) {
      closePopup();
    }
  });

  /* ================= PROFILE LINK ================= */

  // const profileLink = document.getElementById('profile-account-link');
  // if (profileLink) {
  //   profileLink.addEventListener('click', (e) => {
  //     if (profileLink.classList.contains('js-open-auth-popup')) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       showPopup('login');
  //     }
  //   });
  // }

  const profileLink = document.getElementById('profile-account-link');

if (profileLink) {
  profileLink.addEventListener('click', (e) => {
    const customerId = localStorage.getItem('megachat_customer_id');
    console.log("----------------------------")
    if (customerId) {
      // ✅ Logged in → Redirect to profile
      window.location.href = '/pages/account'; // change if needed
       // change if needed
    } else {
      // ❌ Not logged in → Open login popup
      e.preventDefault();
      e.stopPropagation();
      showPopup('login');
    }
  });
}


  /* ================= TAB SWITCHING ================= */

  document.querySelectorAll('.auth-tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      const tabName = tab.dataset.tab;

      document.querySelectorAll('.auth-tab').forEach((t) =>
        t.classList.remove('active')
      );
      tab.classList.add('active');

      document.querySelectorAll('.auth-panel').forEach((panel) =>
        panel.classList.remove('active')
      );

      const targetPanel = document.getElementById(`auth-${tabName}`);
      if (targetPanel) targetPanel.classList.add('active');

      const subtitle = document.querySelector('.auth-subtitle');
      if (subtitle) {
        subtitle.textContent =
          tabName === 'login'
            ? 'Enter your log in details'
            : 'Enter your sign up details';
      }
    });
  });

  function showPopup(tab) {
    openPopup();
    const tabButton = document.querySelector(`.auth-tab[data-tab="${tab}"]`);
    if (tabButton) tabButton.click();
  }

  /* ================= GLOBAL ACCESS ================= */

  window.openLoginPopup = function () {
    showPopup('login');
  };
});









// document.addEventListener("DOMContentLoaded", () => {
//   const popup = document.getElementById("auth-popup");
//   const openBtn = document.getElementById("open-auth-popup");
//   const closeBtn = document.getElementById("close-auth-popup");
//   const overlay = document.querySelector(".auth-overlay");

//   if (!popup) return;

//   // Open popup
//   if (openBtn) {
//     openBtn.addEventListener("click", (e) => {
//       e.preventDefault();
//       popup.classList.remove("hidden");
//       document.body.style.overflow = "hidden";
//     });
//   }

//   // Close popup
//   const closePopup = () => {
//     popup.classList.add("hidden");
//     document.body.style.overflow = "";
//   };

//   if (closeBtn) {
//     closeBtn.addEventListener("click", closePopup);
//   }

//   if (overlay) {
//     overlay.addEventListener("click", closePopup);
//   }

//   // ESC key to close
//   document.addEventListener("keydown", (e) => {
//     if (e.key === "Escape" && !popup.classList.contains("hidden")) {
//       closePopup();
//     }
//   });

//   // Tab switching
//   document.querySelectorAll(".auth-tab").forEach(tab => {
//     tab.addEventListener("click", () => {
//       const tabName = tab.dataset.tab;
      
//       // Update tabs
//       document.querySelectorAll(".auth-tab").forEach(t => {
//         t.classList.remove("active");
//       });
//       tab.classList.add("active");

//       // Update panels
//       document.querySelectorAll(".auth-panel").forEach(panel => {
//         panel.classList.remove("active");
//       });
//       const targetPanel = document.getElementById(`auth-${tabName}`);
//       if (targetPanel) {
//         targetPanel.classList.add("active");
//       }

//       // Update subtitle
//       const subtitle = document.querySelector(".auth-subtitle");
//       if (subtitle) {
//         subtitle.textContent = tabName === "login" 
//           ? "Enter your log in details" 
//           : "Enter your sign up details";
//       }
//     });
//   });

//   function showPopup(tab){
//     popup.classList.remove("hidden");
//     document.body.style.overflow = "hidden";
//     document.querySelector(`.auth-tab[data-tab="${tab}"]`).click();
//   }

//   function handleForm(form, errorBoxId, tab) {
//   if (!form) return;

//   form.addEventListener("submit", async (e) => {
//     e.preventDefault();
//     e.stopImmediatePropagation();

//     const errorBox = document.getElementById(errorBoxId);
//     errorBox.style.display = "none";
//     errorBox.innerHTML = "";

//     try {
//       const response = await fetch(form.action, {
//         method: "POST",
//         body: new FormData(form),
//         headers: {
//           "Accept": "text/html"
//         },
//         redirect: "follow"
//       });

//       // ✅ SUCCESS → Shopify redirected
//       if (response.redirected) {
//         window.location.href = response.url;
//         return;
//       }

//       // ❌ FAILURE → Shopify returned HTML with errors
//       const html = await response.text();

//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, "text/html");

//       const errorNode = doc.querySelector(
//         ".errors, .form__message, .alert, [data-form-error]"
//       );
//       console.log(doc)
//       if (errorNode) {
//         errorBox.innerHTML = errorNode.innerHTML;
//       } else {
//         errorBox.textContent = "Something went wrong. Please try again.";
//       }

//       errorBox.style.display = "block";
//       showPopup(tab);

//     } catch (err) {
//       errorBox.textContent = "Network error. Please try again.";
//       errorBox.style.display = "block";
//     }
//   });
//   }


//   handleForm(document.querySelector('#auth-login form'), "login-errors", "login");
//   handleForm(document.querySelector('#auth-register form'), "register-errors", "register");

//   window.openLoginPopup = function () {
//     const popup = document.getElementById("auth-popup");
//     if (!popup) return;

//     popup.classList.remove("hidden");
//     document.body.style.overflow = "hidden";

//     // Force Login tab
//     const loginTab = document.querySelector('.auth-tab[data-tab="login"]');
//     if (loginTab) loginTab.click();
// };
// });